import { useFlags } from "flagsmith/react";
import type { IFlagsmithFeature } from "flagsmith/types";
import { Navigate, Outlet } from "react-router-dom";

/**
 * Flag gate on `/firm/intercompany`, paired with the sidebar entry in
 * `AppMenu.tsx` so the link and the URL turn off together.
 *
 * INVERSE, like `CloseTrackerGate`: `hide_intercompany` ON hides the page. A
 * flag Flagsmith never returns reads as `undefined` and falls through to
 * rendering, so a missing flag does not dark the page for everyone.
 */
export function IntercompanyGate() {
	const flags = useFlags(["hide_intercompany"]);
	const isHidden = !!(flags.hide_intercompany as IFlagsmithFeature)?.enabled;

	if (isHidden) {
		return <Navigate to="/" replace />;
	}

	return <Outlet />;
}
